<template>
  <div>
    <b-jumbotron class="j-bg">
      <b-container>
        <b-row class="section">
          <b-col md="8" class="my-auto">
            <p class="display-4 pink-font">C Mai Beauty Studio</p>
            <h4 class="p text-muted">Wake Up Beautiful</h4>
            <p class="lead">
              At CMAI Beauty Studio, “Wake Up Beautiful” is more than just
              lashes or brows—it’s a true beauty experience. From the moment you
              arrive, you’ll be welcomed into a calming atmosphere designed for
              complete relaxation. Melt into the warmth of a heated table, let
              the soothing sounds of spa water music surround you, and allow
              your body to fully unwind. Many clients even drift into the
              sweetest nap while their custom lash or brow set is being
              perfected. The best part? You’ll wake up recharged, refreshed, and
              with stunning results—ready to feel effortlessly beautiful every
              single day.
            </p>
            <b-button pill variant="outline-danger" class="mx-1" to="clients">
              Click For Free Consultation
            </b-button>
            <b-button v-b-modal.my-modal pill variant="danger" class="mx-1">
              Sales & Promotions
            </b-button>
          </b-col>
          <b-col md="4" class="my-auto">
            <b-img
              fluid
              src="https://www.dropbox.com/scl/fi/ymfvr30m93vnxvp7v5bud/award.jpg?rlkey=qkuurq7mlha274nrdj52fpgod&st=jq0f2gbp&raw=1"
              alt="Carolynn Mai"
              class="rounded py-4"
            />
          </b-col>
        </b-row>
      </b-container>
      <b-modal
        id="my-modal"
        ref="myModal"
        title="Sale & Promotion"
        header-bg-variant="danger"
        header-text-variant="light"
        hide-footer
      >
        <ul>
          <li>
            <strong>Full Lash Set Discount</strong> <br />
            Enjoy 10% off all full lash sets at our Huntersville location. Limited time—book your appointment today!
          </li>
          <li>
            <strong>Client Referral Program</strong> <br />
            Refer a friend and receive $10 in studio credit for both you and your referral when they book their first service.
          </li>
          <li>
            <strong>Add-On Eyebrow Waxing</strong> <br />
            Add eyebrow waxing to your lash appointment and enjoy $2 off.
          </li>
          <li>
            <strong>Client Feedback Thank You</strong> <br />
            Love your experience? Share your genius feedback with a 5-star review on Google, or Facebook mom groups, and receive $2 off per platform as our thank-you.
          </li>
        </ul>
        <p class="mt-4">
          <em>Reminder: To ensure fairness, only one promotion or discount can be used per appointment.</em>
        </p>
      </b-modal>
    </b-jumbotron>

    <div>
      <div class="bg-danger">
        <b-container>
          <b-row class="py-5 section text-white">
            <b-col md="6" class="my-auto">
              <h1 class="display-4">Hello Gorgeous!</h1>
              <div class="lead">
                <p>
                  I am Carolynn Mai, the heart and soul behind CMAI Beauty
                  Studio, proudly serving Huntersville and Charlotte since 2021.
                  Our studio has been honored as the Best Beauty Salon in town,
                  a recognition of our commitment to excellence.
                </p>
                <p>
                  With over a decade of experience in the beauty industry, I
                  specialize in luxury, personalized services, including
                  customized lash extensions, stunning eyebrow PMU, and
                  rejuvenating skincare. Since 2014, I’ve trained
                  extensively—including microblading, permanent makeup,
                  esthetics, and lash extensions at Aveda Institute
                  Birmingham—blending technical skill with a passion for helping
                  clients feel confident and radiant.
                </p>
                <p>
                  Inspired by my personal skincare journey, I am dedicated to
                  healthy, glowing skin, making every service at CMAI a luxury,
                  transformative experience. My goal is simple: to leave you
                  feeling beautiful, confident, and effortlessly radiant every
                  time you visit.
                </p>
              </div>
            </b-col>
            <b-col class="my-auto">
              <b-img
                fluid
                src="https://www.dropbox.com/scl/fi/aunrgxh1eavxhc9lh9yn9/family.jpg?rlkey=3iu1ai1j1sah2sze7391dlrqh&st=zrvmsg5u&raw=1"
                alt="Carolynn and family"
                class="p-5"
              />
            </b-col>
          </b-row>
        </b-container>
      </div>

      <b-container>
        <b-row class="section pt-5">
          <b-col sm="4">
            <img
              src="https://www.dropbox.com/s/3k4z8dilv6vux3z/about.jpg?raw=1"
              class="rounded img-fluid"
              alt="Carolynn"
            />
          </b-col>
          <b-col>
            <h5>Carolynn Mai</h5>
            <p>
              The talented owner of CMAI BEAUTY STUDIO, boasts more than a
              decade of experience in the Beauty Industry, excelling in
              Permanent Makeup, Lash artistry, and Skincare. Her expertise is
              well-supported by extensive training and certifications acquired
              since 2011, including specialized Microblading and Permanent
              Makeup courses. Carolynn's commitment to top-notch service is
              evident in her proficiency in Lash Extensions, MediClinical
              Aesthetics, and Laser treatments. Her educational achievements
              include graduating from the esteemed Aveda Institute Birmingham's
              esthetician program, where she refined her skills under expert
              mentorship.
            </p>
            <p>
              Driven by a passion for beauty that ignited during her time in
              Vietnam in 2010, Carolynn was inspired by the transformative art
              of Microblading. This passion led her to pursue a career in the
              United States, blending her manicurist background with
              Microblading expertise. Her personal skincare journey, marked by
              struggles with acne since adolescence, fueled her determination to
              explore various treatments, eventually finding solace in glycolic
              acid peels during pregnancy. Carolynn's quest for clear, radiant
              skin not only benefitted her but also inspired her to help others
              achieve healthy skin. Her dedication to skincare and beauty
              showcases her unwavering commitment to excellence and
              transformation.
            </p>
          </b-col>
        </b-row>

        <b-row>
          <hr class="my-5" />
        </b-row>

        <b-row>
          <h5 class="mb-4">Testimonials</h5>
          <b-card-group columns>
            <b-card>
              <b-card-text>
                I had heard such good things about CMAI Beauty Studio from my
                best friend, and she wasn't wrong! I've never had my lashes done
                so I wasn't sure what to expect, but Carolynn was amazing and
                the process was so relaxing it felt like a spa treatment (I
                literally fell asleep on the table!). My lashes are *stunning*
                and I am sold!
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Kara Brown</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                So glad I found Carolynn. I’ve been getting my lashes done for
                over 10 years, in four different states where I’ve lived.
                Carolynn is masterful, and I refuse to go anywhere else in North
                Carolina. She’s an absolute perfectionist, and the retention of
                the lashes is amazing. Highly recommend.
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Jane Kim</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                I have been to CMAI Beauty Studio multiple times. Once for Nano
                brows and additional times for lashes. I couldn't be happier
                with both of my services. Carolyn is extremely friendly and
                knowledgable, she takes extreme pride in her work and stands
                behind it. Her studio is very clean, comfortable and private. I
                am so happy I have found her and will continue to utilize her
                services going forward.
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Rebecca White</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                Each experience in this salon is fantastic! I LOVE my lashes and
                adore Carolynn! My retention is incredible. Carolynn's
                professionalism is unmatched & I appreciate her delightful
                spirit.
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Sabrina Bess</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                Previously I would get my lashes done and within 2 weeks I would
                be in desperate need of a fill. I've gone 3 weeks and the
                retention has been amazing. I don't know her secret, but she
                definitely has that special touch!
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Beckiee Cobb</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                I’ve been to a Carolyn since July 2021. She did a really great
                job on my lashes and my facial as well! I most definitely
                recommend her!! :)
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Ms. Eve</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                Carolynn is awesome at what she does. I went to her after a
                botched lash application. I first went to a shop across the
                street from northlake mall. 3xs, by the third time the tech said
                she could only do half the eye as my lashes were too short. I
                paid for a full set and was very disappointed. I’m pretty sure
                the person used lashes that were too heavy causing the balding.
                I found CMAI beauty the next day and she removed those lashes
                and applied a full set. The lashes were beautiful and full!!!
                I’m going for my 2 week fill and my lashes are still so full and
                gorgeous. I’m trying the microblading too for the first time.
                I’m so happy I found her shop!!
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Marisha Corey</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                I have been considering having Microblading done for quite a
                bit. I have researched and looked at portfolios before moving
                forward. I was highly impressed with Carolynn’s work and
                professionalism when I called and spoke with her!! I am very
                happy with how she listened to me during the consultation to
                ensure I was happy with the final look. I can’t wait to see it
                once it is fully healed!!! 10 of 10 would recommend her. Worth
                the drive!!!
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Amanda Duckett</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                I highly recommend this studio!!!! They were very intentive to
                my needs! Extremely professional! I must say they went above and
                beyond! I had microblading done on my eyebrows. I was very
                self-conscious of my eyebrows and decided to give this a try. I
                am thrilled with the results!! I will definitely be back!!!!!!
                Thank you for giving me the confidence that I so needed!!!!
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Carrie Paccione</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                I highly recommend CMAI Beauty Studio. I was nervous since it
                was my first time getting a chemical peel done, but Carolynn
                explained to me every detail and gave me recommendations for
                after peeling treatment. She was great and very knowledgeable,
                she answered every question about skin care. She really cares
                about her customers. Thank you Carolyn, I cannot wait until my
                next appointment!
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Laura Trigueros</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                I absolutely love this beautiful establishment. Carolynn is very
                knowledgeable on skincare. I had a chemical peel and nano
                infusion theory, and both services was performed great.
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Shae Royster</small>
              </template>
            </b-card>

            <b-card>
              <b-card-text>
                I got my cmai beauty facial done with chemical peel for my acne.
                Just one time with the recommendation skincare at home, it
                cleared up a lot of my acne. Today I come back for the nano
                infusion therapy with procell growth factor. I can’t wait to see
                the result next time. Highly recommended. 😘
              </b-card-text>
              <template #footer>
                <small class="text-muted text-right">Chantha Ly</small>
              </template>
            </b-card>
          </b-card-group>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style scoped>
p {
  font-weight: 200;
}
.jumbotron {
  min-height: 60vh;
  margin: 0px;
}
.j-bg {
  background: url(https://www.dropbox.com/s/dnqg7zudaanq997/models.jpeg?raw=1)
    no-repeat center center fixed;
  position: relative;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.j-bg::before {
  background-color: rgba(255, 255, 255, 0.9);
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
.pink-font {
  color: #d9597b;
  text-shadow: 2px 3px 10px grey;
}
.lead-lg {
  font-size: 1.5rem;
  font-weight: 200;
}
.bg-danger {
  background-color: #d9597b !important;
}
.section-scroll {
  height: 70vh;
  overflow-x: scroll;
}
.section,
.section-col {
  min-height: 50vh;
}
.section-bg {
  background: url(https://www.dropbox.com/s/3k4z8dilv6vux3z/about.jpg?raw=1)
    no-repeat center top;
  background-size: cover;
}
.section-bg2 {
  background: url(https://www.dropbox.com/scl/fi/x1a4qkwk4pwx9gvv9rcpq/ShaylaAustin.jpg?rlkey=o2lp4zznikb4b9ix0dws99tjg&raw=1)
    no-repeat center top;
  background-size: cover;
}
.section-spacer {
  margin: 6rem 0 5rem 0;
}
hr {
  color: darkslategrey;
  width: 100vw;
}
.card-text {
  font-weight: 300;
}
</style>
